<template>
  <navbar />
  <router-view></router-view>
  <QuickSearch />
  <NotificationStack />
  <ConfirmDialog />
</template>

<script>
import navbar from './components/layout/navbar.vue'
import QuickSearch from "@/components/reservation/QuickSearch.vue";
import NotificationStack from "@/components/global/NotificationStack.vue";
import ConfirmDialog from 'primevue/confirmdialog';

export default {
  name: 'App',
  components: {
    QuickSearch,
    navbar,
    NotificationStack,
    ConfirmDialog,
  }
}
</script>
